import React, { useState } from "react";
import {
  Navbar,
  Hero,
  About,
  Projects,
  Services,
  Connect,
  Contact,
  Footer,
  Profile,
  Sidebar,
} from "./components";
import "./App.css";
import { AnimatePresence } from "framer-motion";
import "fontsource-roboto";

import { Switch, Route, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  const [click, setClick] = useState(false);
  const [value, setValue] = useState(true);
  const [color, setColor] = useState(true);

  return (
    <>
      <Navbar
        click={click}
        value={value}
        setClick={setClick}
        setValue={setValue}
        color={color}
        setColor={setColor}
      />
      <Sidebar
        click={click}
        value={value}
        setClick={setClick}
        setValue={setValue}
      />
      <AnimatePresence exitBeforeEnter initial={false}>
        <Switch location={location} key={location.key}>
          <Route exact path="/" component={Hero} />
          <Route path="/about" component={About} />
          <Route path="/projects">
            <Projects color={color} setColor={setColor} />
          </Route>
          <Route path="/services" component={Services} />
          <Route path="/connect" component={Connect} />
          <Route path="/contact" component={Contact} />
          <Route path="/education" component={Profile} />
        </Switch>
      </AnimatePresence>

      <Footer />
    </>
  );
}

export default App;
